// extracted by mini-css-extract-plugin
export default {"BarCharts":"Charts_BarCharts__bTdmv","PieCharts":"Charts_PieCharts__lzOPd"};